export default __webpack_public_path__ + "static/builder_tablet-aeaa79836c66b5a279a467ca4e4ce123.png";